import React, {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useRef,
  lazy
} from 'react';
import Gallery from 'react-grid-gallery';
import { formatMessage } from 'devextreme/localization';
import { confirm } from 'devextreme/ui/dialog';
import { format } from 'date-fns';
import { Button, SelectBox, TextArea } from 'devextreme-react';
import Form, {
  SimpleItem,
  RequiredRule,
  GroupItem,
  ButtonItem,
  EmailRule
} from 'devextreme-react/form';
import List from 'devextreme-react/list';
import FileUploader from 'devextreme-react/file-uploader';
import notify from 'devextreme/ui/notify';
import style from './workingdetailing.module.scss';
import { documentFileTypes, imageFileTypes } from '../../Production/constants';
import { withSuspense } from '../../../utils/functions';
import FileViewer from '../../FIleViewer/FileViewer';

const cursor = {
  subject: null,
  emailTo: null,
  body: null
};

const ModalAddComment = lazy(() => import('../../../components/ModalAddComment'))
const ModalOnHold = lazy(() => import('../../../components/ModalOnHold'))

const WorkingDetailing = ({
  pieceNumId,
  plantId,
  decisionReducer: {
    pieceDecision,
    decisionsList,
    okHoldOn,
    okSave,
    okDecline,
    okAccept
  },
  workingDetailingReducer: {
    listCommits,
    listPhotos,
    listFiles,
    okFiles,
    okCommits,
    okPhoto,
    okSendEmail
  },
  modalReducer: { loadedModalAddComment, loadedModalOnHold },
  getDecision,
  getDecisionsList,
  setHoldOn,
  saveDecision,
  declineDecision,
  acceptDecision,
  userReducer,
  userGetPermissions,
  workingDetailingGetListCommits,
  workingDetailingGetListPhotos,
  workingDetailingAddCommit,
  workingDetailingAddPhoto,
  workingDetailingSendEmail,
  workingDetailingDelCommit,
  workingDetailingDelPhoto,
 modalAddCommentOpen,
  modalOnHoldOpen
}) => {
  const fileUploader = useRef(null);
  const form = useRef(null);
  const [textCommit, setTextCommit] = useState(null);
  const [textCommitChange, setTextCommitChange] = useState(false);
  const [files, setFiles] = useState([]);
  const [listPhotosOnComponent, setListPhotosOnComponent] = useState([]);
  const [listFilesOnComponent, setListFilesOnComponent] = useState([]);
  const [isVisButDelPhoto, setIsVisButDelPhoto] = useState(false);
  const [permissionBtnDecision, setPermissionBtnDecision] = useState(false);
  const [activeDecision, setActiveDecision] = useState(false);
  const [activeBtnDecision, setActiveBtnDecision] = useState(false);
  const [dataSource, setDataSource] = useState({});

  // Выбранные элементы списка
  const [checkedTablistItems, setCheckedTablistItems] = useState([]);

  // Является ли элемент выбранным из списка
  const checkedListItemsIsSameWithCurrent = useMemo(
    () =>
      !!(checkedTablistItems.length && checkedTablistItems.length > 1
      && checkedTablistItems.some((id) => String(id) === String(pieceNumId))),
    [checkedTablistItems, pieceNumId]
  );

  useEffect(() => {
    if (plantId !== 0) {
      userGetPermissions({ plantId });
    }
  }, [
    userGetPermissions,
    plantId
  ]);

  // Получение списка выбранных элементов из таблицы
  useEffect(() => {
    const checkedItems = JSON.parse(localStorage.getItem('checkedItems'))?.map((item) => String(item.pieceNumId)) || [];
    if (checkedItems && checkedItems.length) {
      setCheckedTablistItems(checkedItems);
    }
  }, []);

  /** Получение списка комментариев, вложений и инф. по аттестации */
  useEffect(() => {
    if (pieceNumId) {
      workingDetailingGetListCommits({ pieceNumId });
      workingDetailingGetListPhotos({ pieceNumId });
      if (userReducer.permissions.length
        && userReducer.permissions.indexOf('btnDecision') !== -1) {
        setPermissionBtnDecision(true);
      }
      getDecision({ pieceNumId });
    }
  }, [
    pieceNumId,
    workingDetailingGetListCommits,
    workingDetailingGetListPhotos,
    userReducer,
    getDecision
  ]);

  /** Получение списка решений для выпадающего списка */
  useEffect(() => {
    if (Object.keys(pieceDecision).length) {
      if (pieceDecision.decisionStatus === 3
        || (pieceDecision.decisionStatus === null
        && pieceDecision.onHoldFlag === 'Y')) {
        setActiveDecision(true);
        if (!Object.keys(dataSource).length) {
          setDataSource({
            pieceNumId,
            decision: pieceDecision.decisionStatus
          });
        }
      } else if (pieceDecision.decisionStatus === 0
        || pieceDecision.decisionStatus === 1) {
        setActiveBtnDecision(true);
      }
    }
    getDecisionsList();
  }, [getDecisionsList, pieceDecision, pieceNumId, setDataSource, dataSource]);

  useEffect(() => {
    if (okCommits) {
      setTextCommit(null);
    }
  }, [okCommits]);

  useEffect(() => {
    if (
      okSendEmail
      && form
      && form.current
      && form.current.instance
    ) {
      form.current.instance.resetValues();
      setListPhotosOnComponent((images) => images.map((item) => (
        {
          ...item,
          isSelected: false
        }
      )));
      setListPhotosOnComponent((files) => files.map((item) => (
        {
          ...item,
          isSelected: false
        }
      )));
    }
  }, [okSendEmail, form]);

  useEffect(() => {
    if (
      (okPhoto
      || okFiles)
      && fileUploader
      && fileUploader.current
      && fileUploader.current.instance
    ) {
      setFiles([]);
      fileUploader.current.instance.reset();
    }
  }, [okPhoto, fileUploader, okFiles]);

  useEffect(() => {
    if (listPhotos && listPhotos.length) {
      setListPhotosOnComponent(listPhotos.map((item) => (
        {
          src: item.storedFileUrl,
          thumbnail: item.storedFileUrl,
          thumbnailWidth: 200,
          storedFileName: item.storedFileName,
          attachmentId: item.attachmentId
        }
      )));
      setIsVisButDelPhoto(false);
    } else if (listPhotos && !listPhotos.length) {
      setListPhotosOnComponent([]);
      setIsVisButDelPhoto(false);
    }
  }, [listPhotos]);

  useEffect(() => {
    if (listFiles && listFiles.length) {
      setListFilesOnComponent(listFiles.map((item) => (
        {
          src: item.storedFileUrl,
          thumbnail: item.storedFileUrl,
          thumbnailWidth: 50,
          storedFileName: item.storedFileName,
          attachmentId: item.attachmentId
        }
      )));
      setIsVisButDelPhoto(false);
    } else if (listFiles && !listFiles.length) {
      setListFilesOnComponent([]);
      setIsVisButDelPhoto(false);
    }
  }, [listFiles]);

  /** Добавить в карантин */
  const onClickHoldOn = useCallback(() => {
    if (checkedListItemsIsSameWithCurrent) {
      modalOnHoldOpen(checkedTablistItems)
    } else {
      workingDetailingAddCommit({
        pieceNumIds: [pieceNumId],
        noteText: textCommit
      });
      setHoldOn({
        pieceNumIds: [pieceNumId],
        noteText: textCommit
      });
    }
  }, [
    workingDetailingAddCommit,
    setHoldOn,
    pieceNumId,
    textCommit,
    modalOnHoldOpen,
    checkedListItemsIsSameWithCurrent,
    checkedTablistItems
  ]);

  useEffect(() => {
    if (okHoldOn) {
      setTextCommitChange(false);
      setActiveDecision(true);
    }
  }, [okHoldOn]);

  /** Сохранить решение */
  const onClickSaveHoldOn = useCallback(() => {
    saveDecision(dataSource);
  }, [saveDecision, dataSource]);

  useEffect(() => {
    if (okSave) {
      setActiveBtnDecision(true);
      setActiveDecision(false);
    }
  }, [okSave]);

  /** Принять решение */
  const onClickAccept = useCallback(() => {
    setActiveBtnDecision(false);
    acceptDecision(pieceDecision);
  }, [acceptDecision, pieceDecision]);

  /** Всплывающая подсказка принятия решения */
  useEffect(() => {
    if (okAccept) {
      notify(
        {
          message: formatMessage('workingDetailing').acceptDecision,
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
    }
  }, [okAccept]);

  /** Отклонить решение */
  const onClickDecline = useCallback(() => {
    setActiveDecision(true);
    setActiveBtnDecision(false);
    declineDecision(pieceDecision);
  }, [declineDecision, pieceDecision]);

  /** Всплывающая подсказка отклонения решения */
  useEffect(() => {
    if (okDecline) {
      notify(
        {
          message: formatMessage('workingDetailing').declineDecision,
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'info',
        2000
      );
    }
  }, [okDecline]);

  // Удаление комментария
  const onDelCommit = useCallback((item) => {
    confirm('<div style="width: 300px"></div>', formatMessage('workingDetailing').deleteCommit).then((dialogResult) => {
      if (dialogResult) {
        workingDetailingDelCommit({
          pieceNoteNumId: item.pieceNoteNumId,
          pieceNumId
        });
      }
    });
  }, [pieceNumId, workingDetailingDelCommit]);

  // Отображение комментариев на странице
  const renderListCommits = useCallback((item) => (
    <div className={style.listCommits}>
      <p>{item.noteText}</p>
      <span>{`${format(new Date(item.modDateTime), 'dd.MM.yyyy HH:mm:ss')} ${item.modUserFullName}`}</span>
      <div className="delete">
        <Button type="default"
                stylingMode="text"
                icon="trash"
                onClick={() => onDelCommit(item)}
        />
      </div>
    </div>
  ), [onDelCommit]);
  const renderCommitsList = useMemo(() => (
    <List dataSource={listCommits}
          itemRender={renderListCommits}
    />
  ), [listCommits, renderListCommits]);

  const onSelectImage = useCallback((index, image) => {
    setListPhotosOnComponent((images) => {
      const img = images[index];
      // eslint-disable-next-line no-prototype-builtins
      if (img.hasOwnProperty('isSelected')) {
        img.isSelected = !img.isSelected;
      } else {
        img.isSelected = true;
      }
      if (images.filter((item) => item.isSelected).length
        || listFilesOnComponent.filter((item) => item.isSelected).length
      ) {
        setIsVisButDelPhoto(true);
      } else {
        setIsVisButDelPhoto(false);
      }
      return images;
    });
  }, [listFilesOnComponent]);

  const onSelectFile = useCallback((index) => {
    setListFilesOnComponent((files) => {
      const file = files[index];
      // eslint-disable-next-line no-prototype-builtins
      if (file.hasOwnProperty('isSelected')) {
        file.isSelected = !file.isSelected;
      } else {
        file.isSelected = true;
      }
      if (files.filter((item) => item.isSelected).length
        || listPhotosOnComponent.filter((item) => item.isSelected).length
      ) {
        setIsVisButDelPhoto(true);
      } else {
        setIsVisButDelPhoto(false);
      }
      return files;
    });
  }, [listPhotosOnComponent])

  // Отображение фоток
  const renderPhotosList = useMemo(() => {
    if (listPhotosOnComponent.length || listFilesOnComponent.length) {
      // console.log('listPhotosOnComponent =', listPhotosOnComponent);
      // console.log('listFilesOnComponent =', listFilesOnComponent);
      return (
        <div className={style.filesContainer}>
          <Gallery images={listPhotosOnComponent}
                   onSelectImage={onSelectImage}
                   style={{ width: '0' }}
          />
          <FileViewer filesList={listFilesOnComponent} onSelect={onSelectFile} />
        </div>
      );
    }
    return (<div className={style.textPhoto}>{formatMessage('workingDetailing').notData}</div>);
  }, [
    listFilesOnComponent,
    listPhotosOnComponent,
    onSelectImage,
    onSelectFile
  ]);

  const onOptionChangedCommit = useCallback(({ value }) => {
    setTextCommit(value);
    if (value.length) {
      if (pieceDecision.onHoldFlag === 'N') {
        setTextCommitChange(true);
      }
    }
  }, [pieceDecision]);

  // Сохранение комментария
  const onClickSave = useCallback(() => {
    if (checkedListItemsIsSameWithCurrent) {
      modalAddCommentOpen(checkedTablistItems);
    } else {
      workingDetailingAddCommit({
        pieceNumId,
        pieceNumIds: [pieceNumId],
        noteText: textCommit
      });
    }
  }, [
    pieceNumId,
    textCommit,
    workingDetailingAddCommit,
    checkedListItemsIsSameWithCurrent,
    modalAddCommentOpen,
    checkedTablistItems
  ]);

  // Сохранение фотографии
  const onClickSavePhoto = useCallback(() => {
    workingDetailingAddPhoto({
      pieceNumId,
      files
    });
  }, [
    files,
    pieceNumId,
    workingDetailingAddPhoto
  ]);

  // Загрузка фото
  const onFilesUpload = useCallback(({ value, component }) => {
    // eslint-disable-next-line no-underscore-dangle
    const uploadedFiles = component._files;
    if (uploadedFiles.every((file) => file && file.isValidFileExtension)) {
      setFiles(value);
    } else {
      setFiles([]);
    }
  }, []);
  const renderUploadPhoto = useMemo(() => (
    <FileUploader multiple
                  uploadMode="useForm"
                  ref={fileUploader}
                    allowedFileExtensions={[...imageFileTypes, ...documentFileTypes]}
                  onValueChanged={onFilesUpload}
    />
  ), [onFilesUpload]);

  // Удаление фото
  const onClickDelPhoto = useCallback(() => {
    confirm('<div style="width: 300px"></div>', formatMessage('workingDetailing').deleteSelectPhoto).then((dialogResult) => {
      if (dialogResult) {
        workingDetailingDelPhoto({
          listPhotos: [...listPhotosOnComponent, ...listFilesOnComponent]
            .filter((item) => item.isSelected)
            .map((item) => item.attachmentId),
          pieceNumId
        });
      }
    });
  }, [
    listPhotosOnComponent,
    listFilesOnComponent,
    pieceNumId,
    workingDetailingDelPhoto
  ]);
  const RenderDelPhoto = useCallback(() => (
    <Button type="danger"
            stylingMode="contained"
            text={formatMessage('workingDetailing').deleteText}
            onClick={onClickDelPhoto}
            elementAttr={{ style: !isVisButDelPhoto && 'display: none;' }}
    />
  ), [onClickDelPhoto, isVisButDelPhoto]);

  /** Отображение аттестации */
  // eslint-disable-next-line no-return-assign
  const renderDecision = useMemo(() => (
    <>
      <div>
        <div className="note">
          {pieceDecision.onHoldFlag === 'Y' && 'УЕ в карантине'}
        </div>
        <div className="note">
          {/* eslint-disable-next-line no-param-reassign */}
          {pieceDecision.onHoldFlag === 'Y'
            && pieceDecision.decisionType === 1
            && pieceDecision.decisionStatus !== 3
            && 'Статус "Годный"'}
          {/* eslint-disable-next-line no-param-reassign */}
          {pieceDecision.onHoldFlag === 'Y'
            && pieceDecision.decisionType === 2
            && pieceDecision.decisionStatus !== 3
            && 'Статус "На доработку"'}
          {/* eslint-disable-next-line no-param-reassign */}
          {pieceDecision.onHoldFlag === 'Y'
            && pieceDecision.decisionType === 3
            && pieceDecision.decisionStatus !== 3
            && 'Статус "Отсортировка"'}
        </div>
      </div>
      <div className="optionsRow">
        <div className="optionsData">
          <span>{formatMessage('workingDetailing').decision}</span>
          <SelectBox items={decisionsList.data}
                     displayExpr="value"
                     valueExpr="key"
                     onValueChanged={({ value }) => setDataSource((item) => ({
                       ...item,
                       pieceNumId,
                       decision: value
                     }))}
                     stylingMode="outlined"
                     value={dataSource.decision}
                     disabled={!activeDecision || !permissionBtnDecision}
          />
        </div>
        <div className="optionsData">
          <Button className="saveButton"
                  text={formatMessage('textButton').save}
                  type="default"
                  stylingMode="contained"
                  onClick={onClickSaveHoldOn}
                  disabled={!activeDecision || !permissionBtnDecision}
          />
        </div>
      </div>
      <div className="formButton">
        <Button text={formatMessage('workingDetailing').holdOn}
                type="default"
                stylingMode="contained"
                onClick={onClickHoldOn}
                disabled={!textCommitChange}
        />
      </div>
      <div className="formButton">
        <Button text={formatMessage('workingDetailing').accept}
                type="default"
                stylingMode="contained"
                onClick={onClickAccept}
                disabled={!activeBtnDecision}
        />
        <Button text={formatMessage('workingDetailing').decline}
                type="default"
                stylingMode="contained"
                onClick={onClickDecline}
                disabled={!activeBtnDecision}
        />
      </div>
    </>
  ), [
    activeBtnDecision,
    activeDecision,
    dataSource,
    decisionsList,
    onClickAccept,
    onClickDecline,
    onClickHoldOn,
    onClickSaveHoldOn,
    permissionBtnDecision,
    pieceDecision,
    pieceNumId,
    textCommitChange
  ]);

  // Отправка email
  const formOnSubmit = useCallback((e) => {
    e.preventDefault();
    workingDetailingSendEmail({
      ...cursor,
      attachFileNames: listPhotosOnComponent
        .filter((item) => item.isSelected)
        .map((item) => item.storedFileName)
    });
  }, [listPhotosOnComponent, workingDetailingSendEmail]);
  const renderEmail = useMemo(() => (
    <form method="POST"
          onSubmit={formOnSubmit}
    >
      <Form labelLocation="top"
            width="100%"
            readOnly={false}
            showColonAfterLabel
            showValidationSummary={false}
            formData={cursor}
            ref={form}
      >
        <GroupItem>
          <SimpleItem dataField="subject"
                      editorType="dxTextBox"
                      label={{ text: formatMessage('workingDetailing').labelEmail }}
                      editorOptions={{ stylingMode: 'filled' }}
          >
            <RequiredRule message={formatMessage('workingDetailing').errorSubject} />
          </SimpleItem>
          <SimpleItem dataField="emailTo"
                      editorType="dxTextBox"
                      label={{ text: formatMessage('workingDetailing').labelEmailTo }}
                      editorOptions={{ stylingMode: 'filled' }}
          >
            <RequiredRule message={formatMessage('workingDetailing').errorEmailTo1} />
            <EmailRule message={formatMessage('workingDetailing').errorEmailTo2} />
          </SimpleItem>
          <SimpleItem dataField="body"
                      editorType="dxTextArea"
                      label={{ text: formatMessage('workingDetailing').labelBody }}
                      editorOptions={{ stylingMode: 'filled' }}
          >
            <RequiredRule message={formatMessage('workingDetailing').errorBody} />
          </SimpleItem>
          <ButtonItem horizontalAlignment={checkedListItemsIsSameWithCurrent ? 'left' : 'right'}
                      buttonOptions={{
                        text: formatMessage('workingDetailing').send,
                        type: 'default',
                        useSubmitBehavior: true
                      }}
          />
        </GroupItem>
      </Form>
    </form>
  ), [formOnSubmit, checkedListItemsIsSameWithCurrent]);

  return (
    <div className={style.container}>
      {loadedModalAddComment && withSuspense(<ModalAddComment text={textCommit} pieceNumId={pieceNumId} />)}
      {loadedModalOnHold && withSuspense(<ModalOnHold text={textCommit} pieceNumId={pieceNumId} />)}
      <div className={style.comment}>
        <div className="add">
          <span>{formatMessage('workingDetailing').commit}</span>
          <TextArea height={80}
                    stylingMode="outlined"
                    value={textCommit}
                    onOptionChanged={onOptionChangedCommit}
          />
          <div className={checkedListItemsIsSameWithCurrent ? 'divRightSelectMode' : 'divRight'}>
            <Button type="default"
                    stylingMode="contained"
                    onClick={onClickSave}
                    text={formatMessage('workingDetailing').save}
                    disabled={!textCommit}
            />
          </div>
        </div>
        <div className="list">
          { renderCommitsList }
        </div>
      </div>
      <div className={style.photo}>
        <span>{formatMessage('workingDetailing').files}</span>
        <div className={style.fileExtensions}>
          {formatMessage('workingDetailing').allowedTypes}
          <br />
          .jpg .jpeg .png .msg .pdf .docx .xls .xlsx
        </div>
        { renderUploadPhoto }
        <div className={checkedListItemsIsSameWithCurrent ? 'divRightSelectMode' : 'divRight'}>
          <Button type="default"
                  stylingMode="contained"
                  onClick={onClickSavePhoto}
                  text={formatMessage('workingDetailing').save}
                  disabled={!files.length}
          />
          <RenderDelPhoto />
        </div>
        <div>
          { renderPhotosList }
        </div>
      </div>
      <div className={style.decision}>
        { renderDecision }
      </div>
      <div className={style.email}>
        <span>{formatMessage('workingDetailing').sendToEmail}</span>
        <span className="dopText">{formatMessage('workingDetailing').textPhoto}</span>
        { renderEmail }
      </div>
    </div>
  );
};

export default WorkingDetailing;
